import { useState } from "react";
import { Button, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import styles from "./Popup.module.css";
import { Close } from "@mui/icons-material";
import { X, Check } from "react-feather";

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

const SendInvoicePopup = ({ sendMailBooking, setSendInvoiceModalOpen, setInvoiceMail, invoiceMail }) => {
    const [error, setError] = useState("");

    const handleEmailChange = (e) => {
        setInvoiceMail(e.target.value);
        if (error) setError("");
    };

    const handleSend = () => {
        if (!invoiceMail) {
            setError("This field is Required");
            return;
        }
        if (!EMAIL_REGEX.test(invoiceMail)) {
            setError("Invalid email address");
            return;
        }
        sendMailBooking();
    };

    return (<>
        <DialogTitle id="alert-dialog-title" className={`${styles.PopupTitleBar}`}>
            Send Invoice
            <IconButton onClick={() => setSendInvoiceModalOpen(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
        </DialogTitle>
        <DialogContent className={`${styles.PopupContent}`}>
            <div className={`${styles.FormMainRow}`}>
                <div className={`${styles.FormGroupFull}`}>
                    <TextField
                        fullWidth
                        label="Email Address*"
                        variant="outlined"
                        value={invoiceMail}
                        onChange={handleEmailChange}
                    />
                    {error && <span className={`${styles.ErrorM}`}>{error}</span>}
                </div>
            </div>
            <div className={`${styles.ButtonAction}`}>
                <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={() => setSendInvoiceModalOpen(false)}>Cancel</Button>
                <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} onClick={handleSend}>Send Invoice</Button>
            </div>
        </DialogContent>
    </>);
}

export default SendInvoicePopup;